function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Split `text` into segments marking which parts match a query term, so the UI
 * can wrap matches in <mark> without dangerouslySetInnerHTML.
 *
 * Matching itself lives in `searchIndex`/`searchQuery`; this only decorates
 * text the search has already selected.
 */
export function highlightSegments(
  text: string,
  terms: string[],
): { text: string; match: boolean }[] {
  const esc = terms.map(escapeRegExp).filter(Boolean);
  if (esc.length === 0) return [{ text, match: false }];
  const re = new RegExp(`(${esc.join('|')})`, 'gi');
  const lowerTerms = new Set(terms.map((t) => t.toLowerCase()));
  return text
    .split(re)
    .filter((s) => s !== '')
    .map((s) => ({ text: s, match: lowerTerms.has(s.toLowerCase()) }));
}
